export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.30-1320.12",
  commitId: "0f440d88dc97f0ea110c55a4addc3ee96a8a641f",
  commitTime: "2026-09-30T13:20:12.000Z",
});
